import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import NavigationProvider from '../navigations/navigations';
import { store, persistore } from '../redux/reduxStore';

const App = () => (
  <Provider store={store}>
    <PersistGate persistor={persistore}>
      <NavigationProvider />
    </PersistGate>
  </Provider>
);

export default App;
